module.exports = __webpack_public_path__ + "assets/img/ba604a1c60eaf14b178ea58da2eea24f.png";